import { useEffect } from 'react';

/**
 * Hook that detects clicks outside of the passed ref
 */
export const useFocusOutside = (ref, callback = (e) => {}) => {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback(event);
            }
        }

        function handleTabOutside(event) {
            if (event.keyCode === 9) handleClickOutside(event);
        }
        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keyup', handleTabOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keyup', handleTabOutside);
        };
    }, [ref, callback]);
};
